import "./newsComponent.css"
import {Post} from "react-vk";

export default function News () {

    return (
        <div className="news-container">
            <Post
                elementId={"vk_post_-217192911_8"}
                ownerId={-217192911}
                postId={8}
                hash={"0I83U4vm6A3EXN3U98W8mfsUfuP2"} />
        </div>
    )
}